module.exports = __webpack_public_path__ + "img/COOPERATIVEPARTNER.fd78b9c5.png";